<script lang="ts">
  import { onMount } from "svelte";
  import { initSectionsList, loading, records } from "./task-section.store";
  import MainLayout from "../../layout/MainLayout.svelte";
  import { navigate } from "../../app.logic";

  function onSectionClick(sectionId: number) {
    navigate(`/task/${sectionId}`);
  }

  onMount(initSectionsList);
</script>

<MainLayout>
  <nav class="breadcrumb" aria-label="breadcrumbs">
    <ul>
      <!-- svelte-ignore a11y-missing-attribute -->
      <li class="is-active"><a aria-current="page">Categories</a></li>
    </ul>
  </nav>

  {#if $loading}
    <h2>loading</h2>
  {:else if $records}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div class="task-section-container">
      {#each $records as item}
        <div class="task-section">
          <div class="box noselect clickable" on:click={(_) => onSectionClick(item.oid)}>
            <p class="title">{item.section.name}</p>
            <p class="subtitle">{item.numChallenges} challenges</p>
          </div>
        </div>
      {/each}
    </div>
  {/if}
</MainLayout>

<style>
  .task-section-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .task-section {
    display: block;
    min-width: 30rem;
    width: 30rem;
    margin-right: 2rem;
    margin-bottom: 1rem;
    background-color: #fafafa;
  }

  .clickable {
    cursor: pointer !important;
  }
</style>
